import { VideoPart } from '../Components/Environments/React/VideoEnvironment';
import GameManager from '../GameManager';
import BaseScenarioPart from './BaseScenarioPart';
import { Segments } from './Segments';
var partLoaded = false;
/**
 * Base class for all scenarios
 */
export default class BaseScenario {
	/**
	 * Custom properties for the scenario
	 */
	 public props: any;

	/**
	  * ctor
	  * @param gameManager A reference to the game manager
	  * @param scenarioName The name, or id, of the scenario
	  */
	constructor(public gameManager: GameManager, scenarioName: string) {
		this.props = { name: scenarioName };
	}

	public init(onDone: () => void): void {
		throw new Error('init must be implemented');
	}

	public shouldLoadScenario(): boolean {
		throw new Error('shouldLoadScenario must be implemented');
	}

	/**
	 * @returns Gets all the parts for the scenario
	 */
	public getParts(): BaseScenarioPart<any>[] {
		throw new Error('getParts must be implemented');
	}

	public getEnvironmentProps(): any {
		return null;
	}

	/**
	 * Loads a part
	 */
	public loadPart(partId: string, onDone?: () => void): void {
		var parts = this.getParts();
		var onReady = () => {
			partLoaded = true;
			if(onDone) {
				onDone();
			}
			part.start();
		};
		
		for(var partIndx = 0; partIndx < parts.length; partIndx++) {
			var part = parts[partIndx];
			if(part.partId !== partId) {
				continue;
			}

			var obj: any = {
				partId: part.partId,
				url: (part.videoUrl as any),
			};
			if(partLoaded) {
				onReady();
				return;
			}
			this.loadAllVideosInEnvironment(obj, onReady);
			return;
		}
	}

	 /**
	  * Starts the scenario
	  */
	 public start(): void {
		throw new Error('start must be implemented');
	}
 
	 /**
	  * Starts the scenario once it can be started
	  */
	 public startWhenReady(): void {
		 if(!this.gameManager || !this.gameManager.environment){
			 return;
		 }
		var context = this;
		var onReadyToStart = () => {
			if(!context.shouldLoadScenario()) {
				context.init(() => { context.start(); });
			}
		}
		if(this.gameManager.environment.isReady) {
			onReadyToStart();
		 } else {
			 this.gameManager.environment.props = this.getEnvironmentProps() ?? this.gameManager.environment.getDefaultProps();
			 this.gameManager.environment.onReady = () => {
				onReadyToStart();
			 };
		 }
	 }
 
	 /**
	  * Ends the scenario
	  */
	 public endScenario(): void {
		 var url = new URL(window.location.href);
		 var search_params = url.searchParams;
		 
		 search_params.set('w', '0');
 
		 url.search = search_params.toString();
 
		 window.location.href = url.toString();
		 //window.location.href = process.env.PUBLIC_URL;
	 }

	 /**
	  * The total number of questions in a scenario
	  */
	public get totalNumberOfQuestions(): number {
		throw new Error('totalNumberOfQuestions must be implemented');
	}

	/**
	 * Core needs this to know the path to the audio file
	 * @returns The full path to the sound
	 */
	public getSoundPath(fileName: string): string {
		throw new Error('getSoundPath must be implemented');
	}

	/**
	 * Plays a sound
	 */
	public playSound(fileName: string, onDone?: () => void, oneShot?: boolean, muted?: boolean, useRawPath?: boolean): void {
		this.gameManager.SoundManager.stopAllSounds();
		var context = this;
		context.gameManager.SoundManager.playSound({
			src: useRawPath ? fileName : this.getSoundPath(fileName),
			onEnded: onDone,
			oneShot: typeof oneShot === 'undefined' ? true : oneShot,
			playsInline: true,
			autoPlay: true,
			enableClosedCaptioning: true,
			muted: muted
		});
	}

	public stopSound(fileName: string) {
		var context = this;
		this.gameManager.SoundManager.stopSound(fileName);
		this.gameManager.SoundManager.stopAllSounds();
	}

	/**
	 * plays a Unity3D visualizer sequence
	 */
	public playUnity3DSequence(name: string, props?: any, onDone?: () => void, onError?: () => void): void {
		this.gameManager.customData.dispatch({
			type: 'playSequence',
			value: {
				sequenceName: name,
				props: {
					onDone: onDone,
					onError: onError,
					sequenceProps: props
				}
			}
		});
	}

	/**
	 * Loads all segments for a specific part
	 * @param partSegments All segements belonging to a part
	 */
	 private loadSegments(partSegments: Segments): any {
		var videos = [];
		for(var segmentIndx = 0; segmentIndx < partSegments.segments.length; segmentIndx++) {
			var singleSegment = partSegments.segments[segmentIndx];
			videos.push({
				segmentId: singleSegment.segmentId,
				data: singleSegment.getVideo()
			});
		}

		return videos;
	}

	private loadAllVideosInEnvironment(obj: any, onLoaded?: () => void) {
		var props = this.getEnvironmentProps();

		if(!props) {
			props = this.gameManager.environment.getDefaultProps();
		}
		this.gameManager.environment.props = {...props, part: obj, isDirty: true, onPartsLoaded: onLoaded};
		this.gameManager.onForceUpdate();
	}
}